import { Phone } from "lucide-react";
import { scrollToSection } from "@/App";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-white/5 pt-20 pb-10 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <button
          data-testid="footer-brand"
          onClick={() => scrollToSection("accueil")}
          className="font-display text-[11vw] md:text-[8vw] leading-none text-[#F9F9F9]/90 hover:text-[#D1BFAE] transition-colors duration-500 whitespace-nowrap"
        >
          salle de bain <em>expert</em>
        </button>

        <div className="mt-14 flex flex-col md:flex-row md:items-end justify-between gap-10">
          <div>
            <p className="uppercase tracking-[0.25em] text-xs text-[#D1BFAE]">
              Votre satisfaction en rénovation
            </p>
            <p
              data-testid="footer-rbq"
              className="mt-4 text-xs uppercase tracking-[0.15em] text-[#C4C9CE]"
            >
              RBQ : Q:5881-6240-01
            </p>
            <a
              data-testid="footer-phone-link"
              href="tel:4389851797"
              className="mt-3 inline-flex items-center gap-3 font-display text-3xl md:text-4xl text-[#F9F9F9] hover:text-[#D1BFAE] transition-colors duration-300"
            >
              <Phone size={26} strokeWidth={1.25} className="text-[#D1BFAE]" />
              438-985-1797
            </a>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/5 flex flex-col sm:flex-row justify-between gap-3 text-xs text-[#9aa1a7]">
          <p>© 2026 Salle de Bain Expert. Tous droits réservés.</p>
          <p>Rénovation de salles de bain — de A à Z</p>
          <p>Rive-Nord · Laurentides · Saint-Jérôme</p>
        </div>
      </div>
    </footer>
  );
}
